import { Injectable, signal } from '@angular/core';
import { FormItemEmit, ValueType } from '@shared/components/form-item/model';

@Injectable()
export class FormAbstractComponent {
  form: Record<string, ValueType> = {};
  errorFormArray: Set<string> = new Set();
  isValidForm = signal(false);

  public updateForm($event: FormItemEmit): void {
    this.form = { ...this.form, [$event.key]: $event.value };
    if ($event.isValid) {
      this.errorFormArray.delete($event.key);
    } else {
      this.errorFormArray.add($event.key);
    }
    this.isValidForm.set(this.errorFormArray.size === 0);
  }
}
